/**
 * DateSeparator Component
 * Separatore con data tra gruppi di messaggi
 */

import { memo, useMemo } from 'react';

interface DateSeparatorProps {
  date: Date;
}

export const DateSeparator = memo(function DateSeparator({ date }: DateSeparatorProps) {
  const dateString = useMemo(() => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const isToday = date.toDateString() === today.toDateString();
    const isYesterday = date.toDateString() === yesterday.toDateString();

    if (isToday) return 'Oggi';
    if (isYesterday) return 'Ieri';

    return date.toLocaleDateString('it-IT', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined,
    });
  }, [date]);

  return (
    <div className="flex items-center justify-center py-3">
      <span className="px-3 py-1 text-xs font-medium text-[#787774] bg-[rgba(55,53,47,0.04)] dark:bg-white/5 rounded-full">
        {dateString}
      </span>
    </div>
  );
});
